import PropTypes from 'prop-types';
import React from 'react';

import CompanyLookupField, { CompanyLookupProps } from './CompanyLookupField';

const CyLocationLookupField = (props:Omit<CompanyLookupProps, "filterName">) => <CompanyLookupField {...props} filterName="cy" />

CyLocationLookupField.defaultProps = {
  onSelect: () => {},
  onTextChange: () => {},
  disabled: false,
};

CyLocationLookupField.propTypes = {
  initialValue: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onTextChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  lookupId: PropTypes.string,
  onTabNext: PropTypes.func,
  onTabPrevious: PropTypes.func,
};


export default React.memo(CyLocationLookupField);
